export default String.raw`
.news {
    width: 100%;
    padding: 0 9%;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 24px;

        a {
            display: flex;
            align-items: center;
            @include button;

            svg {
                margin-left: 4px;
                width: 16px;
                height: 16px;
            }
        }
    }

    &__slide {
        width: calc(100% / 4);
        .blog-item {
            width: 100%;

            &__read {
                position: relative;
                flex-direction: row;
                justify-content: space-between;

                &-top {
                    flex-direction: column;
                    align-items: flex-start;
                    row-gap: 16px;

                    &-tags {
                        width: 100%;
                        order: 1;
                    }

                    time {
                        order: 2;
                        position: relative;
                        bottom: 2px;
                    }
                }

                &-bottom {
                    justify-content: end;
                    align-items: end;

                    &-time {
                        display: none;
                    }

                    &-button {
                        position: absolute;
                    }
                }
            }
        }
    }

    &__swiper {
        overflow-x: hidden;
    }

    &__container {
        position: relative;
        width: 100%;
    }

    &__arrows {
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: absolute;
        width: 100%;
        aspect-ratio: 810 / 109;

        &-prev,
        &-next {
            position: absolute;
            z-index: 90;

            svg {
                width: 16px;
                height: 16px;
            }
        }

        &-prev {
            left: -24px;

            svg {
                rotate: 180deg;
            }
        }

        &-next {
            right: -24px;
        }
    }
}
`